module.exports = __webpack_public_path__ + "img/Close.f2207798.svg";